export default {
	search(type, params, cb, ecb) {
		this.http
			.get(`/search/${type}/`, { params })
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	rank(key, cb, ecb) {
		this.http
			.get('/search/rank/' + key)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	}
}
